var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1284 12.9769L27.4015 12.089L25.9353 12.4401L25.2337 11.5661L22.9109 13.0816L24.7251 12.8004L25.21 13.6049L26.4654 13.5117L26.6559 13.9706C25.1987 14.7322 23.5475 15.0172 21.7736 14.9523L21.8131 14.9807L15.8967 17.8729L17.4965 12.8365L16.8503 12.6867L16.0294 13.7907C13.2465 12.8638 10.3624 11.4857 7.58309 10.0218C6.67557 11.7331 5.14491 13.8044 3.08432 13.7026L4.04027 9.39307L0.229492 1.78667C3.12357 1.78667 6.55739 5.45771 7.92976 7.07499L13.7188 6.94187L14.2961 0L21.1583 6.77077L31.7695 6.52672C30.9506 9.56565 29.6959 11.6435 28.1284 12.9769ZM20.3778 8.17493L19.2652 10.9756L20.1303 10.9647L21.297 8.17877L20.3778 8.17493ZM22.2941 8.18325L21.2081 10.9513L22.0637 10.9404L23.175 8.18709L22.2941 8.18325ZM25.853 8.31445C24.6901 8.31445 24.6609 10.1167 25.7721 10.1167C27.0903 10.1167 26.9934 8.31445 25.853 8.31445Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShark);
export default __webpack_public_path__ + "static/media/shark.0fa272fe0621cd1230a7d053e14b0186.svg";
export { ForwardRef as ReactComponent };